import { MaskLines, Reveal } from "@/components/site/Motion";
import { Label } from "@/components/site/Ui";
import DiagnosticForm from "@/components/site/forms/DiagnosticForm";
import { useSeo } from "@/lib/seo";

const how = [
  { t: "Vous décrivez votre commerce", d: "Activité, ville, objectifs : deux minutes." },
  { t: "J'étudie votre présence", d: "Site, fiche Google, boutons d'appel et de réservation." },
  { t: "On en parle", d: "Je reviens vers vous par e-mail avec les pistes repérées." },
];

export default function Diagnostic() {
  useSeo({
    title: "Diagnostic de visibilité digitale",
    description: "Demandez un diagnostic de votre visibilité : j'étudie votre site, votre fiche Google et vos points de contact pour repérer ce qui peut vous apporter plus de clients.",
    path: "/diagnostic",
  });
  return (
    <section className="wrap pt-32 pb-20 md:pt-44" data-testid="diagnostic-page">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Label className="mb-8">Diagnostic de visibilité digitale</Label>
          <MaskLines as="h1" onLoad className="display h-lg" lines={["Votre commerce est-il", "aussi visible qu'il pourrait l'être ?"]} />
          <Reveal delay={0.25}>
            <p className="lead mt-6">J'analyse votre présence actuelle pour repérer ce qui peut vous apporter plus d'appels et de réservations.</p>
            <ol className="mt-10 border-t border-ink/20">
              {how.map((h, i) => (
                <li key={h.t} className="flex gap-5 border-b border-ink/20 py-4">
                  <span className="font-mono text-[13px] text-accent">0{i + 1}</span>
                  <div><p className="font-semibold">{h.t}</p><p className="mt-1 text-[15px] text-mute">{h.d}</p></div>
                </li>
              ))}
            </ol>
            <p className="mt-5 text-[14px] leading-relaxed text-mute">Pas d'audit automatique : je lis et j'étudie chaque demande moi-même.</p>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-6 lg:col-start-7">
          <div className="border border-ink/15 bg-white/60 p-6 md:p-10">
            <h2 className="display mb-8 text-[1.9rem] leading-tight md:text-[2.3rem]">Découvrez les opportunités de votre présence digitale.</h2>
            <DiagnosticForm />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
